export function items(state) {
  return state.items
}

export function item(state) {
  return state.item
}

export function pagination(state) {
  return state.pagination
}

export function companies(state) {
  return state.companies
}

export function statistics(state) {
  return state.statistics
}

export function projectsItems(state) {
  return state.projectsItems
}

export function platforms(state) {
  return state.platforms
}
